import useNotificationHandler from "hooks/useNotificationHandler";
import { MUTATION_KEYS, QUERY_KEYS } from "library/shared";
import { Attachment } from "library/types";
import { useMutation, useQueryClient } from "react-query";
import api from "service/api";

type Params = {
  countryCode: number | string;
  benefitCategoryTag: number | string;
  clientInternalNumberGOS: number | string;
  attachmentName: string;

  payload: Attachment;
};
const updateAttachment = async ({
  countryCode,
  clientInternalNumberGOS,
  benefitCategoryTag,
  attachmentName,

  payload,
}: Params) => {
  const response = await api.patch(
    `/benefitcategory/attachment/${countryCode}/${clientInternalNumberGOS}/${benefitCategoryTag}/${attachmentName}`,

    payload
  );

  return response.data as Attachment;
};
export function useUpdateCategoryAttachment(refetch = true) {
  const queryClient = useQueryClient();
  const { handleAddAxiosErrorNotification } = useNotificationHandler();

  return useMutation(updateAttachment, {
    mutationKey: MUTATION_KEYS.updateCategoryAttachment,
    onSuccess: () => {
      if (refetch) {
        queryClient.refetchQueries({
          queryKey: QUERY_KEYS.benefitCategories,
        });
      }
    },
    onError: (error) => {
      // handle error
      handleAddAxiosErrorNotification(error);
    },
  });
}
